module.exports = __webpack_public_path__ + "static/scale-model-of-chattanooga-hop-trolley-tours-in-chattanooga-tennessee-a3fe9bf14dddfeaf5aebaa249a523e03.png";